import { Button, Card, Col, Container, Row, Modal } from "react-bootstrap";
import { ExpandableComponent } from "../../components/ExpandableComponent";
import { useEffect, useState } from "react";
import {analytics, logEvent, firestoreDB } from "../../App";

import { doc, updateDoc, increment } from "firebase/firestore";
import softwareVersions from "./softwareVersions.json"

interface Version {
  version: string;
  date: string;
  link: string;
  description: string[];
}

export const DownloadPage = () => {
  useEffect(() => {
    document.title = "PARSO - Download";
  }, []);

  const radiationSoftwareVersions: Version[] = softwareVersions.radiationSoftware;

  const latestVersion = radiationSoftwareVersions[0];
  const olderVersions = radiationSoftwareVersions.slice(1);

  // const [showModal, setShowModal] = useState(false);
  // const handleShow = () => setShowModal(true); // This is actually useless now since the download button is no longer disabled
  // const handleClose = () => setShowModal(false);

  const trackDownload = async () => {
  const downloadRef = doc(firestoreDB, "downloads", "parso");
  await updateDoc(downloadRef, {
    count: increment(1),
  });
  };

  return (
    <Container style={{ marginBottom: "100px" }}>
      <h3
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          textAlign: "center",
          fontWeight: "600",
          fontSize: "2.5rem",
        }}
      >
        Downloads
      </h3>

      <Card className="shadow-lg rounded">
        <Card.Body>
          <Container fluid>
            <Card.Text style={{ fontSize: "1.2rem", color: "#333" }}>
              Download the latest version of PARSO below:
            </Card.Text>

            {renderVersionCard(latestVersion, trackDownload)}

            <Row style={{ marginTop: "30px" }}>
              <ExpandableComponent
                closedStateText="View older versions"
                openedStateText="View older versions"
                buttonVarient="secondary"
              >
                {olderVersions.map((version) => renderVersionCard(version, trackDownload))}
              </ExpandableComponent>
            </Row>

          </Container>
        </Card.Body>
      </Card>

      {/* Modal Component */}
      {/* <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Download unavailable</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Download access is temporarily disabled as the software is under patent review.
          <br />
          Please contact the authors for further inquiries.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
    </Container>
  );
};

const renderVersionCard = (version: Version, customFunction: () => void) => (
  <Card
    style={{
      marginTop: "20px",
      border: "none",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    key={version.version}
    className="rounded-lg hover-shadow"
  >
    <Card.Header
      style={{
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
        fontSize: "1.3rem",
        textAlign: "center",
        borderBottom: "2px solid #ddd",
      }}
    >
      {"Version " + version.version}
    </Card.Header>
    <Card.Body>
      <Container fluid>
        <Row>
          <Card.Subtitle className="mb-2 text-muted" style={{ fontSize: "1.2rem" }}>
            {"Released " + version.date}
          </Card.Subtitle>

          <Card.Text className="justify-text" style={{ fontSize: "1.2rem" }}>
            Changelog:
            <ul style={{ listStyle: "inside" }}>
              {version.description.map((change, index) => (
                <li key={index}>{change}</li>
              ))}
            </ul>
          </Card.Text>

          <a href={version.link} target="_blank" download>
          <Button
            variant="primary"
            className="my-2 w-100"
            style={{
              padding: "12px 20px",
              fontSize: "1.2rem",
              fontWeight: "bold",
              borderRadius: "30px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              transition: "background-color 0.3s ease, transform 0.3s ease",
            }}
            onClick={() => {
              customFunction();
              logEvent(analytics, "download_button_click", {
                version: version.version,
                time_clicked: new Date().toLocaleString("en-CA", { timeZone: "America/Toronto" }),
              });
            }}
          >
            Download v{version.version}
          </Button>
          </a>
        </Row>
      </Container>
    </Card.Body>
  </Card>
);
